import { Component, EventEmitter, Input, NgZone, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { CSEService } from '../../services/cse.service';
import { UtilService } from '../../services/util.service';
import {
    FuelRateTier
} from '../../models/models';

@Component({
    selector: 'fuel-rate-tier-grid',
    templateUrl: './fuel-rate-tier-grid.component.html',
    standalone: false
})
export class FuelRateTierGrid implements OnChanges {
    @Input() tableID: number = 0;
    @Input() tableHeader: string = "Fuel Rate Tiers";
    @Output() onRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public tableGrid!: GridComponent;

    public isAdd: boolean = false;
    public isEdit: boolean = false;

    public tableList: FuelRateTier[] = [];
    public tableItem: FuelRateTier = {} as FuelRateTier;
    public employeeID: number = 0;

    public minValue: number = 0;
    public maxValue: number = 0;

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 0, sort: [{ dir: 'asc', field: "sortOrder" }] };

    constructor(private cseService: CSEService, private utilService: UtilService, private dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getTableList();
    }

    private getTableList() {
        this.utilService.isLoading = true;
        this.cseService.getFuelRateTiersByFuelRateID(this.tableID).subscribe(result => {
            this.utilService.isLoading = false;
            this.tableList = result.resultCollection;
            this.tableList = this.tableList.sort((left, right): number => {
                if (left.sequence < right.sequence) return -1;
                if (left.sequence > right.sequence) return 1;
                return 0;
            });
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.tableList = orderBy(this.tableList, this.gridState.sort);

        this.gridData = process(this.tableList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.tableGrid == null) return;
            this.tableGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public save() {
        this.cseService.saveFuelRateTier(this.tableItem).subscribe(result => {
            this.isAdd = false;
            this.isEdit = false;
            this.getTableList();
        });
    }

    public addNew() {
        this.tableItem = {
            fuelRateTierID: 0,
            fuelRateID: this.tableID,
            sequence: 0,
            minValue: 0,
            maxValue: 0,
            charge: 0
        };
        this.isAdd = true;
    }

    public edit(item: FuelRateTier) {
        this.tableItem = item;
        this.isEdit = true;
        var idx = this.tableList.findIndex(t => t.fuelRateTierID == item.fuelRateTierID);
        if (idx > 0) {
            var prevRate = this.tableList[idx - 1];
            this.minValue = prevRate.maxValue + 0.001;
        }
        else {
            this.minValue = 0;
        }
        if (idx < this.tableList.length - 1) {
            var nextRate = this.tableList[idx + 1];
            this.maxValue = nextRate.minValue - 0.001;
        }
        else {
            this.maxValue = 1000;
        }
        console.log("edit", idx, "item min/max", item.minValue, item.maxValue, "min/max", this.minValue, this.maxValue);
    }

    public cancel() {
        this.isAdd = false;
        this.isEdit = false;
        this.getTableList();
    }

    public close() {
        this.isAdd = false;
        this.isEdit = false;
        this.onRefresh.emit();
    }
}
